/**
  Builds a full width image text section that includes an SVG badge.
*/

export const buildFullWidthImageText = () => {
  const elements = document.querySelectorAll("[js-full-width-image-text]");
  elements.forEach((element) => {
    const svgBadge = element.querySelector(".svg_badge");
    if (!svgBadge || svgBadge.length == 0) {
      return;
    }
    let animated = false;
    window.addEventListener("scroll", function () {
      const top_of_element =
        element.getBoundingClientRect().top + window.pageYOffset;
      const top_of_screen = window.pageYOffset;
      if (
        !animated &&
        top_of_screen + window.innerHeight / 3 > top_of_element
      ) {
        animated = true;
        svgBadge.classList.add("animate__bounceIn");
      }
    });
  });
};
